import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Articulo } from "@/shared/types/articulo";

export interface ArticuloEditRequest {
    codigo: string,
    numeroItem?: string,
    rubroId: string,
    nombre: string,
    costo: number,
    iva: number,

    descripcion?: string,
    precios?: number[],
    cantidadMinima?: number | "",
    cantidadPorCaja?: number | "",
    imagen?: File | null
}

export async function editArticulo(id: string, request: ArticuloEditRequest): Promise<Articulo> {
    await sleep(1000);
    const response = await api.putForm("articulos/" + id, request);
    return response.data;
}

export function useEditArticuloMutation(id: string, mutationConfig: MutationConfig<Articulo, ArticuloEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: ArticuloEditRequest) => await editArticulo(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["articulos"] });
        },
    })
}

export interface EditArticuloMutationProps {
    id: string,
    mutationConfig?: MutationConfig<Articulo, ArticuloEditRequest>,
    children?: (mutationResult: MutationResult<Articulo, ArticuloEditRequest>) => ReactNode
}

export function EditArticuloMutation({
    id,
    children,
    mutationConfig
}: EditArticuloMutationProps) {
    const mutationResult = useEditArticuloMutation(id, mutationConfig);
    return children && children(mutationResult)
}